
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import Amplify from 'aws-amplify';
import '../styles/global.scss';
import reducer from '../redux';
import { ComponentLookupContextProvider } from '../ComponentLookupContext';
import { CourseTopicContextProvider } from '../CourseTopicContext';
import i18nConfig from '../../i18n'
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { getLocaleFromApi } from '../utils/localeUtils';

import mapping from '../utils/mappings';

import pathsData from '../buildArtifacts/paths';
import tealium from '../utils/tealium';

const { pageCourseTopicNested: paths } = pathsData;

Amplify.configure({
  Auth: {
    identityPoolId: process.env.IDENTITY_POOL_ID,
    region: process.env.COGNITO_REGION,
    userPoolId: process.USER_POOL_ID,
    userPoolWebClientId: process.USER_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: process.env.ENDPOINT_NAME,
        endpoint: process.env.ENDPOINT_URL,
        region: process.env.ENDPOINT_REGION
      }
    ]
  },
  aws_appsync_graphqlEndpoint: process.env.APPSYNC_GRAPHQL_ENDPOINT,
  aws_appsync_region: process.env.APPSYNC_REGION,
  aws_appsync_authenticationType: process.env.APPSYNC_AUTHENTICATION_TYPE
});

function MyApp({ Component, pageProps, err }) {
  const { t, lang } = useTranslation();

  const router = useRouter();
  useEffect(() => {
    if (window.coveoua) {
      window.coveoua("init", process.env.ANALYTICS_API_KEY, process.env.ANALYTICS_ENDPOINT);
      coveoua("send", "pageview");
    }
    const timer= setTimeout(() => {
        const exisitingScript = document.querySelector("script[src*='privacy_consent.bundle']");
        let scriptUrl;
        if (exisitingScript) {
          scriptUrl = exisitingScript.src.split("?")[0]
          exisitingScript.remove()
        }
        const script = document.createElement("script");
        script.src = `${scriptUrl}?v=${Date.now()}`;
        script.defer = true;
        document.body.appendChild(script)
      }, 2000);
    return()=>clearTimeout(timer)
  }, [router.asPath]);

  useEffect(() => {
    const fetchInitialLocale = async () => {
      const apiLocale = await getLocaleFromApi();
      const localeSet = ['id', 'ms', 'da_DK', 'es_ES', 'nl_NL', 'nb_NO', 'en_GB', 'fr_CA', 'pl', 'ru', 'sv_SE', 'uk_UA', 'th_TH', 'zh_CN', 'zh_TW', 'ko'].includes(apiLocale);
      if (router && apiLocale !== lang && apiLocale !== 'en' && !localeSet && apiLocale !== 'pt_BR') {
        const cleanPath = router.asPath.replace(/[?&]fallback=true/g, '').replace(/[?&]$/, '');
        router.push(cleanPath, undefined, { locale: apiLocale });
      } else if (apiLocale === 'en') {
        const cleanPath = router.asPath.replace(/[?&]fallback=true/g, '').replace(/[?&]$/, '');
        router.push(cleanPath, undefined, { locale: 'en-US' });
      } else if (apiLocale === 'pt_BR') {
        const normalizedLocale = router?.locale.toLowerCase()
        if (normalizedLocale !== 'pt-br') {
          const cleanPath = router.asPath.replace(/[?&]fallback=true/g, '').replace(/[?&]$/, '');
          router.push(cleanPath, undefined, { locale: 'pt-br' });
        }
      } else if (localeSet) {
        let cleanPath = router.asPath.replace(/([?&])fallback=true(&|$)/, '').replace(/[?&]$/, '');
        if (!cleanPath.includes('fallback=true')) {
          cleanPath += (cleanPath.includes('?') ? '&' : '?') + 'fallback=true';
        }
        router.push(cleanPath, undefined, { locale: 'en-US' });
      };
    }
    if (router.pathname !== "/preview") {
      fetchInitialLocale();
    }

  }, []);
  useEffect(() => {
    const consentCookieName = "__Secure-dbx_consent";
    console.log("secureCookie", document.cookie)
    const hasCookie = (name) => {
      return document.cookie
        .split(";")
        .map((cookie) => cookie.trim())
        .some((cookie) => cookie.startsWith(name + "="));
    };

    const waitForCookie = ({
      name,
      callback,
      interval = 1000,
      maxAttempts = 30,
    }) => {
      let attempts = 0;
      const timer = setInterval(() => {
        attempts++;
        console.log(`:mag: Attempt ${attempts} for cookie: ${name}`);

        if (hasCookie(name)) {
          console.log(`:white_check_mark: Cookie ${name} found,${document.cookie}. Calling tealium()...`);
          clearInterval(timer);
          callback();
        } else if (attempts >= maxAttempts) {
          clearInterval(timer);
          console.warn(`:warning: Cookie ${name} not found after ${maxAttempts} attempts.`);
        }
      }, interval);
    };

    waitForCookie({
      name: consentCookieName,
      callback: tealium, // just call your existing function
    });
  }, []);


  return (
    <>
      <Head>
        {i18nConfig && i18nConfig?.locales.length > 0 &&
          i18nConfig?.locales.map((lang) => (
            <link
              key={lang}
              rel="alternate-text"
              hrefLang={lang}
              href={`https://learn.dropbox.com/${lang}${router.asPath}`}>
            </link>
          ))}
      </Head>
      <ComponentLookupContextProvider componentLookup={(contentType) => mapping[contentType]}>
        <CourseTopicContextProvider value={paths}>
          <Component {...pageProps} err={err} />
        </CourseTopicContextProvider>
      </ComponentLookupContextProvider>
    </>
  );
}

const __Page_Next_Translate__ = reducer.withRedux(MyApp);


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      
    });
  